<div class="w-full flex flex-col md:flex-row items-center justify-end pb-2 sm:pb-2">
    <div class="flex space-x-3 mt-2 md:mt-0">
        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new()"
            *ngIf="(documentMeasurements$ | async)?.length === 0">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1">Add</span>
        </button>
        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="deleteSelectedRows()"
            *ngIf="selection.selected.length > 0">
            <mat-icon [svgIcon]="'delete_forever'"></mat-icon>
            <span class="ml-2 mr-1">All Delete</span>
        </button>
    </div>
    <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
        {{alert.message}}
    </fuse-alert>

</div>
<div class="relative overflow-x-auto overflow-y-auto">

    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="w-5 p-1 text-center pr-6"></th>
                <th scope="col" class="w-5 text-center p-2">
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelectedCheckBox"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [color]="'primary'"
                        [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>

                <th scope="col" class="w-16 px-0 py-1 text-center">Order</th>
                <th scope="col" class="w-40 p-0 pr-2 text-center">Flat /
                    Unit No</th>
                <th scope="col" class="w-40 p-0 pr-2 text-center" *ngIf="reportType === 'FlatOrOfficeOrShop'">Carpet
                    Area (In Sq.Mt)
                </th>
                <th scope="col" class="w-40 p-0 pr-2 text-center" *ngIf="reportType === 'LandAndBuilding'">Land (In
                    Sq.Mt)</th>
                <th scope="col" class="w-40 p-0 pr-2 text-center">BuiltUp Area (In Sq.Mt)</th>
                <th scope="col" class="w-40 p-0 pr-2 text-center" *ngIf="reportType === 'FlatOrOfficeOrShop'">Super
                    BuiltUp Area
                    (In
                    Sq.Mt)</th>
                <th scope="col" class="w-32 px-0 py-2 text-center">
                    <span class="sr-only">Actions</span>
                </th>

            </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngIf="documentMeasurements$ | async as documentMeasurements">
                <ng-container *ngIf="documentMeasurements.length; else noDocumentMeasurement">
                    <tr class="border-b dark:border-gray-700 hover:bg-blue-50 dark:hover:bg-gray-900 transition"
                        *ngFor="let documentMeasurement of documentMeasurements; let i = index; let lastIndex = last; trackBy: trackByFn">
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700 bg-gray-50">
                            <mat-icon class="flex items-center cursor-move text-gray-400"
                                cdkDrag>drag_indicator</mat-icon>
                        </td>
                        <td class="w-5 text-center align-middle p-2 border border-gray-200 dark:border-gray-700">
                            <mat-checkbox [(checked)]="documentMeasurement.selected" [color]="'primary'"
                                (change)="updateCheckedList($event,documentMeasurement)"></mat-checkbox>
                        </td>
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="number"
                                class="w-12 bg-transparent px-1 py-0.5 text-sm h-7 text-center border-0 focus:ring-0 focus:outline-none transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.orderIndex" readonly />
                        </td>

                        <!-- Unit No flatPlotNo -->
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.flatPlotNo"
                                (focus)="onInputInit(documentMeasurement, 'flatPlotNo')"
                                (blur)="onFieldChange(documentMeasurement, 'flatPlotNo')" required />
                        </td>

                        <!-- carpetArea for flat and land -->
                        <td class="text-right align-middle border border-gray-200 dark:border-gray-700"
                            *ngIf="reportType === 'FlatOrOfficeOrShop'">
                            <input matInput type="number"
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.carpetArea"
                                (focus)="onInputInit(documentMeasurement, 'carpetArea')"
                                (blur)="onFieldChange(documentMeasurement, 'carpetArea')" required />
                        </td>

                        <td class="text-right align-middle border border-gray-200 dark:border-gray-700"
                            *ngIf="reportType === 'LandAndBuilding'">
                            <input matInput type="number"
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.carpetArea"
                                (focus)="onInputInit(documentMeasurement, 'carpetArea')"
                                (blur)="onFieldChange(documentMeasurement, 'carpetArea')" />
                        </td>

                        <!-- BuiltUp Area (In Sq.Mt) -->
                        <td class="text-right align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.builtUpArea"
                                (focus)="onInputInit(documentMeasurement, 'builtUpArea')"
                                (blur)="onFieldChange(documentMeasurement, 'builtUpArea')" />
                        </td>

                        <!--  Super BuiltUp Area-->
                        <td class="text-right align-middle border border-gray-200 dark:border-gray-700"
                            *ngIf="reportType === 'FlatOrOfficeOrShop'">
                            <input matInput
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="documentMeasurement.superBuiltUpArea"
                                (focus)="onInputInit(documentMeasurement, 'superBuiltUpArea')"
                                (blur)="onFieldChange(documentMeasurement, 'superBuiltUpArea')" />
                        </td>
                        <td
                            class="flex items-center justify-end gap-1 align-middle border border-gray-200 dark:border-gray-700">
                            <button class="ml-2" mat-icon-button *ngIf="lastIndex && !documentMeasurement.isEditing"
                                (click)="new()">
                                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            </button>
                            <button class="ml-2" mat-icon-button *ngIf="documentMeasurement.isEditing">
                                <mat-icon svgIcon="close" (click)="cancelNewRow(i)"></mat-icon>
                            </button>
                            <button mat-icon-button *ngIf="documentMeasurement.id !== 0"
                                (click)="delete(documentMeasurement.id)">
                                <mat-icon svgIcon="delete_forever"></mat-icon>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>
        <ng-template #noDocumentMeasurement>
            <tr>
                <td colspan="6" class="text-center py-4 text-gray-400 font-semibold">There
                    are no
                    Document Measurement!</td>
            </tr>
        </ng-template>
        <tfoot *ngIf="(documentMeasurements$ | async)?.length !== 0">
            <tr class="font-semibold text-gray-900 dark:text-white bg-gray-50 dark:bg-gray-900">
                <td colspan="4" class="px-2 py-3 border border-gray-200 dark:border-gray-700">Total (Sq.Mt)</td>
                <td class="text-right">
                    <label class="text-sm text-gray-500 block">Area (In Sq.Mt)</label>
                    <input matInput [value]="report.deedArea | number:'1.2-2':'en-IN'"
                        class="align-middle border border-gray-200 dark:border-gray-700" readonly>
                </td>
                <td class="text-right">
                    <label class="text-sm text-gray-500 block">BuiltUp (In Sq.Mt)</label>
                    <input matInput [value]="report.deedBuiltUp | number:'1.2-2':'en-IN'"
                        class="align-middle border border-gray-200 dark:border-gray-700" readonly>
                </td>
                <td class="text-right" *ngIf="reportType === 'FlatOrOfficeOrShop'">
                    <label class="text-sm text-gray-500 block">SBU (In Sq.Mt)</label>
                    <input matInput [value]="report.deedSuperBuiltUp | number:'1.2-2':'en-IN'"
                        class="align-middle border border-gray-200 dark:border-gray-700" readonly>
                </td>
                <td class="px-0 py-0 border border-gray-200 dark:border-gray-700"></td>
            </tr>
        </tfoot>
    </table>
</div>